<template>
  <WdsStack direction-column class="tw-px-2">
    <slot name="action">
      <WdsStack justify-space-between>
        <WdsText>
          {{ $t('Contract cancelled') }}
        </WdsText>
      </WdsStack>
      <WdsText secondary>
        <div class="tw-font-normal">
          {{
            isWorker
              ? $t('This contract was cancelled before work began.')
              : $t('The contract was cancelled prior to its start date, and the hire did not proceed.')
          }}
        </div>
      </WdsText>
    </slot>
  </WdsStack>
</template>

<script lang="ts" setup>
import { WdsStack, WdsText } from '@worksome/wds-components'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { useAccountCapabilities } from '@/composables/useAccountCapabilities'

const props = defineProps<{
  hireId: string
}>()

const { isWorker } = useAccountCapabilities()
</script>
